namespace TabAurous.OMS {
    export interface ColorQualityMappingForm {
        Code: Serenity.StringEditor;
        QualityId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
    }

    export class ColorQualityMappingForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ColorQualityMapping';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ColorQualityMappingForm.init)  {
                ColorQualityMappingForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(ColorQualityMappingForm, [
                    'Code', w0,
                    'QualityId', w1,
                    'StoneColorId', w1
                ]);
            }
        }
    }
}
